import './App.css';
// import Layout from './Layout';
import { ThemeProvider } from '@mui/material/styles';
import AppRouter from './router/Router';
import theme from './theme/theme';
import { QueryClientProvider } from 'react-query';
import queryClient from './lib/react-query-client';
function App() {
  return (
    <div className="App">
       <QueryClientProvider client={queryClient}>
     <ThemeProvider theme={theme}>
     {/* <Layout/> */}
     <AppRouter />
     </ThemeProvider>
     </QueryClientProvider>
    </div>
  );
}

export default App;